import { Dialog } from 'primereact/dialog'
import { Dropdown, DropdownProps } from 'primereact/dropdown'
import React, { FC, useEffect, useState } from 'react'
import { SystemDDLEntityForHighlights } from '../../../interface/pdf-pin';
import Loader from '../../../components/loader';
import { IsNullOrUndefined, IsStringNullEmptyOrUndefined } from '../../../utils/null-check';
import { useHighlightModelStore, usePDFAnnotationStore } from '../../../store/pdf-pin.store';
import { FINAL_COLOR, svgUrlToPngBytes } from '../utils/pdf-pin.shared';
import { toast } from 'react-toastify';
import { toastOptObj } from '../../../utils/constants';



interface SystemHighlightModelProp {

}

const SystemHighlightModel: FC<SystemHighlightModelProp> = ({ }) => {

    const [isLoading, setIsLoading] = useState(false);

    const { isOpen, onClose } = useHighlightModelStore();

    const [selectedSystem, setSelectedSystem] = useState("");

    const [initialSystem, setInitialSystem] = useState("")

    const { selectedPageId, systemDDL, highlights, selectedHighlight, setIconCache, updateHighlight, updateHighlightInPage, setSelectedHighlight, deleteHighlight, removeHighlightFromPage } = usePDFAnnotationStore();


    const selectedSystemTemplate = (option: SystemDDLEntityForHighlights, props: DropdownProps) => {
        if (!IsNullOrUndefined(option)) {
            return (
                <div className="d-flex align-items-center gap-2">
                    <img src={option.systemIcon} style={{ width: '25px' }} />
                    <div>{option.systemName}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    const systemOptionTemplate = (option: SystemDDLEntityForHighlights) => {
        return (
            <div className="d-flex align-items-center gap-2">
                <img src={option.systemIcon} style={{ width: '25px' }} />
                <div>{option.systemName}</div>
            </div>
        );
    };

    const getSelectedSystem = () => {
        const selectedHighlightDetail = highlights.find((item) => item.id === selectedHighlight);

        if (selectedHighlightDetail && !IsNullOrUndefined(selectedHighlightDetail)) {
            setSelectedSystem(selectedHighlightDetail.systemId);
            setInitialSystem(selectedHighlightDetail.systemId);
        }

        return "";
    }

    const handleSubmit = async () => {
        try {
            setIsLoading(true);

            const selectedHighlightDetail = highlights.find((item) => item.id === selectedHighlight);
            if (selectedHighlightDetail && !IsNullOrUndefined(selectedHighlightDetail) && selectedHighlightDetail.solutionId && !IsStringNullEmptyOrUndefined(selectedHighlightDetail.solutionId)) {
                return toast.error("This solution is already linked to a highlight, so you won’t be able to update it in the system!", { ...toastOptObj });
            }

            const systemDetail = systemDDL.find((item) => item.id === selectedSystem)
            if (!systemDetail) return;

            // Convert to PNG bytes
            const iconPngBytes: any = await svgUrlToPngBytes(
                systemDetail.systemIcon,
                selectedHighlightDetail && selectedHighlightDetail.color ? selectedHighlightDetail.color : FINAL_COLOR,
                60,
                60
            );

            // Create image object and wait for load
            const blob = new Blob([iconPngBytes], { type: "image/png" });
            const url = URL.createObjectURL(blob);

            await new Promise<void>((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    setIconCache(selectedHighlight, img);
                    resolve();
                };
                img.onerror = reject;
                img.src = url;
            });

            // Update highlights in store and UI
            updateHighlight(selectedHighlight, {
                systemIcon: systemDetail.systemIcon,
                systemId: systemDetail.id,
                systemName: systemDetail.systemName,
            });

            updateHighlightInPage(selectedPageId, selectedHighlight, {
                systemIcon: systemDetail.systemIcon,
                systemId: systemDetail.id,
                systemName: systemDetail.systemName,
            });

            setSelectedHighlight("");
        } catch (err) {
            console.error("Error loading system icon:", err);
        } finally {
            setIsLoading(false);
            onClose();
        }
    };

    useEffect(() => {
        getSelectedSystem()
    }, [selectedHighlight])

    return (
        <>
            <Loader isLoading={isLoading} />
            <Dialog visible={isOpen} onHide={() => onClose()} draggable={false} resizable={false} style={{ width: "600px" }} closable={false}>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label style={{ fontSize: "14px" }}>
                                SELECT SYSTEM
                            </label>
                            <div>
                                <Dropdown
                                    className='w-100'
                                    value={selectedSystem}
                                    onChange={(e) => { setSelectedSystem(e.value) }}
                                    options={systemDDL}
                                    valueTemplate={selectedSystemTemplate}
                                    optionLabel='systemName'
                                    itemTemplate={systemOptionTemplate}
                                    optionValue='id'
                                    placeholder='Select system'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 ">
                        <div className='d-flex align-items-center justify-content-between'>
                            <div>
                                <button className="btn btn-cancel text-dark m-0" onClick={() => {
                                    onClose()
                                }}>Cancel</button>
                            </div>
                            <div>
                                <button className="btn btn-danger text-light m-0" onClick={(e) => {
                                    e.stopPropagation()
                                    deleteHighlight(selectedHighlight);
                                    removeHighlightFromPage(selectedPageId, selectedHighlight)
                                    setSelectedHighlight("");
                                    onClose();
                                }} >Delete</button>
                                <button className="btn btn-primary mx-2" disabled={initialSystem === selectedSystem} onClick={handleSubmit}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default SystemHighlightModel